// packages/ui/src/cn.ts
// Tailwind class merge utility — shared across all @ominiflow/ui components.
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
